import React, { useState, useEffect } from 'react'
import { newFetch, GET } from '../../helpers/fetch'
import PageShell, { EmptyState } from '../../components/UI/PageShell'

const FAQ = () => {
  const [FAQs, setFAQs] = useState([])

  const fetchFAQs = async () => {
    let api_path = `/faq`
    let response = await newFetch(GET, api_path)

    if (response.success) {
      setFAQs(response.data)
    }
  }

  useEffect(() => {
    fetchFAQs()
  }, [])

  return (
    <PageShell title="Frequently asked questions" eyebrow="Help center" description="Find answers to common questions about your employee workspace.">
      <div className="accordion portal-content-card" id="accordionFAQs">
        {FAQs.length > 0 &&
          FAQs.map((faq) => (
            <div className="card" key={faq.id}>
              <div className="card-header" id={`heading-${faq.id}`}>
                <h2 className="mb-0">
                  <button
                    className="btn btn-link text-brand"
                    type="button"
                    data-toggle="collapse"
                    data-target={`#collapse-${faq.id}`}
                    aria-expanded={faq === FAQs[0]}
                    aria-controls={`collapse-${faq.id}`}
                  >
                    {faq.title}
                  </button>
                </h2>
              </div>

              <div
                id={`collapse-${faq.id}`}
                className={`collapse ${faq === FAQs[0] ? 'show' : ''}`}
                aria-labelledby={`heading-${faq.id}`}
                data-parent="#accordionFAQs"
              >
                <div className="card-body">{faq.description}</div>
              </div>
            </div>
          ))}
        {!FAQs.length && <EmptyState icon="fa-question-circle" title="No FAQs available" description="Help articles will appear here when they are published." />}
      </div>
    </PageShell>
  )
}

export default FAQ
